import { Hero } from '@/components/organisms/Admin/Skills/Hero'

export function SkillsPage() {
	return (
		<>
			<Hero />
		</>
	)
}
